export enum UiStorageKey {
  AdministratorsHiddenColumns = 'administratorsHiddenColumns',
  AllowOfflineEdit = 'AllowOfflineEdit',
  AssetsHiddenColumns = 'assetsHiddenColumns',
  BackupVersionsHashCode = 'backupVersionsHashCode',
  BetaRequestedFeatures = 'BetaRequestedFeatures',
  BetaSidepanelOff = 'BetaSidepanelOff', // TODO Remove after take statistic
  ComputersHiddenColumns = 'ComputersHiddenColumns',
  ComputersBackupHiddenColumns = 'ComputersBackupHiddenColumns',
  ComputersRMMHiddenColumns = 'ComputersRMMHiddenColumns',
  CustomizeDashboard = 'CustomizeDashboard',
  DashboardSelectedTag = 'DashboardSelectedTag',
  destinationAsDefault = 'destinationAsDefault',
  DisableAllToasts = 'DisableAllToasts',
  DocumentsHiddenColumns = 'DocumentsHiddenColumns',
  FreeRmmLicense2024 = 'freeRmmLicense2024',
  HideMainUserMenuBadge = 'hideMainUserMenuBadge',
  HideMSP2FAModal = 'hideMSP2FAModal',
  HideNotificationsMenuBadge = 'hideNotificationsMenuBadge',
  HidePasswordRecoveryComputersModal = 'hidePasswordRecoveryComputersModal',
  HidePasswordRecoveryModal = 'hidePasswordRecoveryModal',
  HidePermissionPresetsHint = 'hidePermissionPresetsHint',
  HideRMMCEWelcomeModal = 'hideRMMCEWelcomeModal',
  LicensesHiddenColumns = 'licensesHiddenColumns',
  LicensesGroupByCompanyHiddenColumns = 'licensesGroupByCompanyHiddenColumns',
  LicensesGroupedHiddenColumns = 'licensesGroupedHiddenColumns',
  MonitoringHiddenColumns = 'monitoringHiddenColumns',
  MainMenuCollapsed = 'MainMenuCollapsed',
  MainMenuLayout = 'MainMenuLayout',
  RmmVersionsHashCode = 'rmmVersionsHashCode',
  ShowOfflineEditBanner = 'ShowOfflineEditBanner',
  StoragesHiddenColumns = 'storagesHiddenColumns',
  StorageTreeDestinationsHiddenColumns = 'storageTreeDestinationsHiddenColumns',
  StorageTreeUsersHiddenColumns = 'storageTreeUsersHiddenColumns',
  StorageTreeComputersHiddenColumns = 'storageTreeComputersHiddenColumns',
  StorageUsageHiddenColumnsByCompany = 'StorageUsageHiddenColumnsByCompany',
  StorageUsageHiddenColumnsByDestination = 'StorageUsageHiddenColumnsByDestination',
  TicketsHiddenColumns = 'TicketsHiddenColumns',
  TicketsViewMode = 'TicketsViewMode',
  TicketsDoNotAskAboutZohoBeforeCreation = 'TicketsDoNotAskAboutZohoBeforeCreation',
  RAVersionsHashCode = 'raVersionsHashCode',
  ShowStoragesFeedback = 'showStoragesFeedback',
  HideGetDemoButton = 'hideGetDemoButton',
  HideGetDemoMenuBadge = 'hideGetDemoMenuBadge',
  TicketsSidePanelFullScreen = 'TicketsSidePanelFullScreen',
  HidePaymentMethodModal = 'hidePaymentMethodModal',
  RmmLastSidepanelTab = 'RmmLastSidepanelTab'
}

export type UiStorageType = {
  [UiStorageKey.AdministratorsHiddenColumns]?: string[];
  [UiStorageKey.AllowOfflineEdit]?: string;
  [UiStorageKey.BackupVersionsHashCode]?: string;
  [UiStorageKey.BetaRequestedFeatures]?: string;
  [UiStorageKey.BetaSidepanelOff]?: boolean; // TODO Remove after take statistic
  [UiStorageKey.ComputersHiddenColumns]?: string[];
  [UiStorageKey.ComputersBackupHiddenColumns]?: string[];
  [UiStorageKey.ComputersRMMHiddenColumns]?: string[];
  [UiStorageKey.CustomizeDashboard]?: string[];
  [UiStorageKey.DashboardSelectedTag]?: string;
  [UiStorageKey.destinationAsDefault]?: { [key: string]: string };
  [UiStorageKey.DisableAllToasts]?: 'true' | 'false';
  [UiStorageKey.DocumentsHiddenColumns]?: string[];
  [UiStorageKey.FreeRmmLicense2024]?: 1 | 2 | '1' | '2';
  [UiStorageKey.HideMainUserMenuBadge]?: 'true' | 'false';
  [UiStorageKey.HideMSP2FAModal]?: 'true' | 'false';
  [UiStorageKey.HideNotificationsMenuBadge]?: 'true' | 'false';
  [UiStorageKey.HidePasswordRecoveryComputersModal]?: 'true' | 'false';
  [UiStorageKey.HidePasswordRecoveryModal]?: 'true' | 'false';
  [UiStorageKey.HideRMMCEWelcomeModal]?: boolean;
  [UiStorageKey.MainMenuCollapsed]?: 'true' | 'false';
  [UiStorageKey.MainMenuLayout]?: 'horizontal' | 'vertical';
  [UiStorageKey.RmmVersionsHashCode]?: string;
  [UiStorageKey.ShowOfflineEditBanner]?: 'true' | 'false';
  [UiStorageKey.StoragesHiddenColumns]?: string[] | string;
  [UiStorageKey.StorageTreeDestinationsHiddenColumns]?: string[];
  [UiStorageKey.StorageTreeUsersHiddenColumns]?: string[];
  [UiStorageKey.StorageTreeComputersHiddenColumns]?: string[];
  [UiStorageKey.FreeRmmLicense2024]?: 1 | 2 | '1' | '2';
  [UiStorageKey.RAVersionsHashCode]?: string;
  [UiStorageKey.HideRMMCEWelcomeModal]?: boolean;
  [UiStorageKey.StorageUsageHiddenColumnsByCompany]?: string[];
  [UiStorageKey.StorageUsageHiddenColumnsByDestination]?: string[];
  [UiStorageKey.ShowStoragesFeedback]?: 'true' | 'false';
  [UiStorageKey.HideGetDemoButton]?: 'true' | 'false';
  [UiStorageKey.HidePermissionPresetsHint]?: 'true' | 'false';
  [UiStorageKey.HideGetDemoMenuBadge]?: 'true' | 'false';
  [UiStorageKey.LicensesHiddenColumns]?: string[];
  [UiStorageKey.LicensesGroupByCompanyHiddenColumns]?: string[];
  [UiStorageKey.LicensesGroupedHiddenColumns]?: string[];
  [UiStorageKey.MonitoringHiddenColumns]?: string[];
  [UiStorageKey.HidePaymentMethodModal]?: 'true' | 'false';
  [UiStorageKey.TicketsSidePanelFullScreen]?: 'true' | 'false';
  [UiStorageKey.RmmLastSidepanelTab]?: string;
  [UiStorageKey.TicketsHiddenColumns]?: string[] | string;
  [UiStorageKey.TicketsViewMode]?: 'table' | 'split';
  [UiStorageKey.TicketsDoNotAskAboutZohoBeforeCreation]?: 'true' | 'false';
};
